import { createFileRoute } from "@tanstack/react-router";
import { legacyRedirectTo } from "@/lib/legacy-redirect";

// Legacy URL /app/integrations → redirect to /app/sources. The page itself
// has moved to apps/admin-ui/src/routes/app/sources/.
export const Route = createFileRoute("/app/integrations/")({
  beforeLoad: legacyRedirectTo("/app/sources"),
});
